import { StandardProps } from "../componentMap";
import { ChanelBannerUI } from "./ChanelBannerUI";
import { DiorBannerUI } from "./DiorBannerUI";

export function BrandBanner({ product }: Pick<StandardProps, "product">) {
  const { brand } = product;

  if (brand && brand.name && brand.name.toUpperCase() === "CHANEL") {
    return <ChanelBannerUI />;
  }

  if (brand && brand.name && brand.name.toUpperCase() == "DIOR") {
    return <DiorBannerUI />;
  }

  return null;
}
